import * as React from 'react';
import './style/index.scss';
import { ErrorBoundary } from './ErrorBoundary';
import { ContactUsFormProps } from './types/ContactUsFormProps';
import { ContactUsFormWrapper } from './ContactUsFormWrapper';

export class ContactUsForm extends React.Component<ContactUsFormProps> {
    render(): React.ReactNode {
        const caseDeflection = this.props.showCaseDeflection === undefined ?
            false : this.props.showCaseDeflection;
        return (
            <div className="contact-us-form">
                <ErrorBoundary>
                    <ContactUsFormWrapper
                        productName={this.props.productName}
                        pageSource={this.props.pageSource}
                        onSubmitFn={this.props.onSubmitFn}
                        onClose={this.props.onClose}
                        articles={this.props.articles}
                        initialSearchTerms={this.props.initialSearchTerms}
                        isVisible={this.props.isVisible}
                        searchTermCallBack={this.props.searchTermCallBack}
                        goToArticle={this.props.goToArticle}
                        showCaseDeflection={caseDeflection}
                    />
                </ErrorBoundary>
            </div>
        );
    }
}

export default { ContactUsForm };